import React, { useState } from "react";
import "./Dashboard.css";

/* MUI */
import {
  Grid,
  Typography,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
} from "@mui/material";

/* MUI icons */
import LocationOffIcon from "@mui/icons-material/LocationOff";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import GroupsIcon from "@mui/icons-material/Groups";
import ForumIcon from "@mui/icons-material/Forum";

/* Images – adjust paths if needed */
import heroImg from "../../../../../assets/images/kaaba_hero.png";
import thumb1Img from "../../../../../assets/images/kaaba_hero.png";
import thumb2Img from "../../../../../assets/images/kaaba_hero.png";

export default function Dashboard() {
  const [tab] = useState(0);

  /* Ritual guidance cards */
  const guides = [
    { id: 1, title: "The Kaaba and Tawaf", excerpt: "It is a long established fact that a reader will be distracted by the readable content…", img: thumb1Img },
    { id: 2, title: "The Kaaba and Tawaf", excerpt: "It is a long established fact that a reader will be distracted by the readable content…", img: thumb2Img },
    { id: 3, title: "The Kaaba and Tawaf", excerpt: "It is a long established fact that a reader will be distracted by the readable content…", img: thumb2Img },
    { id: 4, title: "The Kaaba and Tawaf", excerpt: "It is a long established fact that a reader will be distracted by the readable content…", img: thumb2Img },
  ];

  return (
    <div className="dash__wrap">
      {/* Hero */}
      <Card className="dash__hero">
        <CardActionArea disableRipple>
          <CardMedia
            component="img"
            image={heroImg}
            alt="Kaaba"
            className="dash__heroImage"
          />
          <div className="dash__heroOverlay">
            <Typography variant="h4" component="h2">
              Explore&nbsp;Hajj
            </Typography>
            <Typography variant="body2">
              It is a long established fact that a reader will be
            </Typography>
          </div>
        </CardActionArea>
      </Card>

      {/* Community */}
      <section className="dash__section">
        <Typography variant="h6" className="dash__sectionTitle">
          Community
        </Typography>

        <Grid container spacing={1} className="dash__actionGrid">
          {[
            { label: "Lost\nLocation", icon: <LocationOffIcon /> },
            { label: "Find\nMember", icon: <PersonSearchIcon /> },
            { label: "View\nGroups", icon: <GroupsIcon /> },
            { label: "View\nForums", icon: <ForumIcon /> },
            { label: "Profile\nSettings", icon: <PersonSearchIcon /> },
            { label: "Support", icon: <ForumIcon /> },
          ].map((btn, i) => (
            <Grid item xs={6} sm={4} md={2} key={i}>
              <button className="dash__actionBtn">
                <span className="dash__actionIcon">{btn.icon}</span>
                {btn.label.split("\n").map((l) => (
                  <span key={l} className="dash__actionLabel">{l}</span>
                ))}
              </button>
            </Grid>
          ))}
        </Grid>
      </section>

      {/* Ritual Guidance */}
      <section className="dash__section">
        <div className="dash__sectionHeader">
          <Typography variant="h6" className="dash__sectionTitle">
            Explore Ritual Guidance
          </Typography>
          <button className="dash__viewAll">View All</button>
        </div>

        <Grid container spacing={2} className="dash__cardRow">
          {guides.map((g) => (
            <Grid item xs={12} sm={6} md={3} key={g.id}>
              <Card className="dash__guideCard">
                <CardActionArea>
                  <CardMedia
                    component="img"
                    image={g.img}
                    alt={g.title}
                    className="dash__guideImage"
                  />
                  <CardContent className="dash__guideContent">
                    <Typography variant="subtitle1" className="dash__guideTitle">
                      {g.title}
                    </Typography>
                    <Typography variant="body2" className="dash__guideExcerpt">
                      {g.excerpt}
                    </Typography>
                    <button className="dash__readMore">Read&nbsp;More</button>
                  </CardContent>
                </CardActionArea>
            </Card>
             </Grid>
          ))}
        </Grid>
      </section>
    </div>
  );
}
